import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

export const EmptyPortfolioIllustration = (props: SVGProps): JSX.Element => {
  const { title = 'EmptyPortfolio', className, ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={cn('fill-current', className)}
      viewBox="0 0 160 90"
      fill="none"
      {...restProps}
    >
      <title>{title}</title>
      <g clipPath="url(#clip0_2910_19495)">
        <path
          fill="#fff"
          d="M158.626 34.787c.773 0 1.4-.624 1.4-1.393 0-.77-.627-1.393-1.4-1.393s-1.399.624-1.399 1.393c0 .77.626 1.393 1.399 1.393M140.266 43.565c3.139 0 5.683-2.532 5.683-5.657 0 3.125 2.544 5.657 5.683 5.657-3.139 0-5.683 2.532-5.683 5.657 0-3.125-2.544-5.657-5.683-5.657"
        />
        <path
          stroke="#fff"
          strokeLinecap="square"
          strokeMiterlimit={10}
          strokeWidth={0.773}
          d="M140.266 43.565c3.139 0 5.683-2.532 5.683-5.657 0 3.125 2.544 5.657 5.683 5.657-3.139 0-5.683 2.532-5.683 5.657 0-3.125-2.544-5.657-5.683-5.657Z"
        />
        <path
          stroke="#5580F6"
          fill="none"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="m37.227 83.91 10.782-48.217a2.95 2.95 0 0 1 2.88-2.3h69.699c1.886 0 3.289 1.74 2.88 3.573l-10.99 50.618"
        />
        <path
          fill="#000"
          d="M36.75 74.729V42.372a2.947 2.947 0 0 1 2.953-2.94h69.838a2.95 2.95 0 0 1 2.954 2.94v44.15"
        />
        <path
          stroke="#fff"
          fill="none"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M36.75 74.729V42.372a2.947 2.947 0 0 1 2.953-2.94h69.838a2.95 2.95 0 0 1 2.954 2.94v44.15"
        />
        <path
          fill="#5580F6"
          stroke="#5580F6"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M109.741 89.454H40.067a2.95 2.95 0 0 1-2.873-2.259l-8.746-36.718c-.439-1.845.965-3.616 2.873-3.616h69.673c1.367 0 2.555.934 2.873 2.259l8.746 36.718c.439 1.845-.964 3.616-2.872 3.616Z"
        />
        <path
          stroke="#5580F6"
          fill="none"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M127.696 82.3c8.403 8.362 22.251 8.137 30.932-.503L128.2 51.513c-8.68 8.64-8.907 22.423-.504 30.786Z"
        />
        <path
          fill="#fff"
          stroke="#fff"
          strokeMiterlimit={10}
          strokeWidth={1.7}
          d="M123.455 39.192c6.447 0 11.674-5.202 11.674-11.618s-5.227-11.62-11.674-11.62-11.674 5.203-11.674 11.62 5.227 11.618 11.674 11.618Z"
        />
        <path
          stroke="#000"
          strokeMiterlimit={10}
          strokeWidth={2.014}
          d="m116.633 27.814 5.204 4.085 8.436-8.65"
        />
        <path
          stroke="#fff"
          fill="none"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M29.096 62.037c2.552 0 4.62-2.059 4.62-4.598 0-2.54-2.068-4.598-4.62-4.598s-4.62 2.058-4.62 4.598 2.069 4.598 4.62 4.598Z"
        />
        <path
          stroke="#fff"
          fill="none"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M29.105 60.21a2.78 2.78 0 0 0 2.785-2.771 2.78 2.78 0 0 0-2.785-2.772 2.78 2.78 0 0 0-2.785 2.772 2.78 2.78 0 0 0 2.785 2.772ZM9.787 64.641c0 2.54-2.07 4.599-4.62 4.599S.547 67.18.547 64.64s2.069-4.598 4.62-4.598c2.55 0 4.62 2.06 4.62 4.598Z"
        />
        <path
          stroke="#fff"
          fill="none"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M5.168 67.414a2.78 2.78 0 0 0 2.785-2.772 2.78 2.78 0 0 0-2.785-2.772 2.78 2.78 0 0 0-2.785 2.772 2.78 2.78 0 0 0 2.785 2.772Z"
        />
        <path
          fill="#000"
          stroke="#fff"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M29.758 88.065S27.087 64.704 17.522 60.21c0 0-.676 11.462 12.236 27.854Z"
        />
        <path
          stroke="#fff"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M8.844 66.937s12.46 8.363 13.03 22.78"
        />
        <path
          stroke="#fff"
          fill="none"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M5.75 75.853s4.744 8.247 14.927 12.78c0 0-4.174-12.467-14.927-12.78Z"
        />
        <path
          stroke="#fff"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M5.75 75.853s11.385 5.857 14.927 12.78M29.102 62.037l1.812 27.857"
        />
        <path
          stroke="#5580F6"
          fill="none"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="M13.605 49.938s-5.99-9.713 3.604-13.83c4.813-2.067 8.318 2.659 5.029 4.82-3.29 2.16-12.233-11.063 6.13-17.138"
        />
        <path fill="#5580F6" d="m37.478 13.005-7.251-9.618L70.445.644z" />
        <path fill="#fff" d="m37.477 13.005 11.078 14.183 22.898-26.01z" />
        <path
          stroke="#000"
          strokeMiterlimit={10}
          strokeWidth={1.208}
          d="m72.55.513-35.8 12.932"
        />
        <path
          stroke="#fff"
          fill="none"
          strokeLinecap="square"
          strokeMiterlimit={10}
          strokeWidth={1.007}
          d="M149.173 22.928a3.22 3.22 0 0 0 3.227-3.212 3.22 3.22 0 0 0-3.227-3.212 3.22 3.22 0 0 0-3.228 3.212 3.22 3.22 0 0 0 3.228 3.212Z"
        />
        <mask
          id="mask0_2910_19495"
          width={12}
          height={18}
          x={33}
          y={10}
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'luminance' }}
        >
          <path
            fill="#fff"
            d="m35.769 10.738 2.42 3.176 6.64 8.494-11.29 4.78z"
          />
        </mask>
        <g mask="url(#mask0_2910_19495)">
          <path
            stroke="#fff"
            fill="none"
            strokeMiterlimit={10}
            strokeWidth={1.007}
            d="m37.7 12.597-1.927 10.859 9.112-4.03"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2910_19495">
          <path fill="#fff" d="M0 0h160v90H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
